import moment from "moment";
import {
  ActionIcon,
  Badge,
  Box,
  Button,
  ComboboxItem,
  Flex,
  Grid,
  Loader,
  LoadingOverlay,
  Menu,
  MultiSelect,
  rem,
  Select,
  Text,
  TextInput,
  Title,
  Tooltip,
} from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { useDebouncedState, useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  IconBrandBootstrap,
  IconBrandGrammarly,
  IconBuildingSkyscraper,
  IconBuildingWarehouse,
  IconCalendar,
  IconCaretDown,
  IconChartCandle,
  IconArrowsExchange,
  IconCubeSend,
  IconFileExport,
  IconFileUpload,
  IconPackage,
  IconPrinter,
  IconSearch,
  IconTagStarred,
  IconTransferIn,
  IconTransferOut,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import * as React from "react";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import {
  _timerDelayClick,
  repositoryDelivery,
  repositoryMdm,
  repositoryPos,
  styleTableMantine,
} from "../../_base/_const/_constVar";
import _breadcrumb from "../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import {
  formatDateNotTimeZone,
  formatDateTime,
  formatDateTransfer,
} from "../../common/FormatDate/FormatDate";
import { BASE_API_DELIVERY } from "../../config";
import ServiceRepairInWardWarranty from "./ServiceRepairInWardWarranty";
import ServiceRepairVoucherCodeCell from "./ServiceRepairVoucherCodeCell";
import {
  getServiceRepairVoucherDetail,
  mapDetailSerialsToRows,
  ServiceRepairVoucherType,
} from "./serviceRepairVoucherDetail";
import { _localization } from "../../config/location";
import { green } from "../../const/variables";
import { MessageResponse } from "../../model/MessageResponse";
import { DefectiveItem } from "../../model/TblFaultyItemList";
import {
  getBranchSelectMdm,
  getTblDMInventory,
  getTblDmProcessingMethodSelect,
} from "../../service/getSelectApi";
import PrinterServiceReturnCustomers from "./PrinterServiceReturnCustomers";
import ServiceRepairInWardWarrantyVendor from "./ServiceRepairInWardWarrantyVendor";
import ServiceRepairOutWardWarrantyVendor from "./ServiceRepairOutWardWarrantyVendor";
import ServiceRepairReturnCustomers from "./ServiceRepairReturnCustomers";
import UpdateWarrantyTerm from "../Warranty/DefectiveGoodsList/UpdateWarrantyTerm";
import { getValueById } from "../../_base/helper/FunctionHelper";
import { normalizeZnsPhoneNumber } from "../../service/znsService";

type ColumnPinningType = {
  left?: string[];
  right?: string[];
};

const ServiceRepairDefectiveGoodsList = () => {
  const navigate = useNavigate();
  //data and fetching state
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<any[]>([]);
  const [dataTemp, setDataTemp] = useState<DefectiveItem[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [dataVendorSelect, setDataVendorSelect] = useState<ComboboxItem[]>([]);
  const [dataBranchSelect, setDataBranchSelect] = useState<ComboboxItem[]>([]);
  const [dataInventorySelect, setDataInventorySelect] = useState<
    ComboboxItem[]
  >([]);
  const [dataTblProcessingMethod, setDataTblProcessingMethod] = useState<
    ComboboxItem[]
  >([]);
  const [dataItemStatusSelect] = useState<any[]>([
    { label: "Test lỗi", value: "Test lỗi" },
    { label: "Đang gửi NCC", value: "Đang gửi nhà cung cấp" },
    { label: "Chờ test", value: "Chờ test" },
    { label: "Đổi mã", value: "Đổi mã" },
    { label: "Test OK", value: "Test OK" },
    // { label: "Gửi lại NCC", value: "Gửi lại nhà cung cấp" },
    { label: "Hủy", value: "Hủy" },
    { label: "Trả khách", value: "Trả khách" },
  ]);
  const [dataDebtStatusSelect] = useState<any[]>([
    { label: "Nợ khách", value: "Nợ khách" },
    { label: "Đã trả khách", value: "Đã trả khách" },
    { label: "Nợ hàng kho", value: "Nợ hàng kho" },
    { label: "Đã trả hàng kho", value: "Đã trả hàng kho" },
    { label: "NCC nợ", value: "NCC nợ" },
    { label: "Đã nhập từ NCC", value: "Đã nhập từ NCC" },
  ]);
  const [selectStatusSerial, setSelectStatusSerial] = useState<string | null>(
    null,
  );
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [isReturnedBorrowGoods, setIsReturnedBorrowGoods] = useState<any>(null);
  const [listErrorNum, setListErrorNum] = useState<any[]>([]);
  const [sourceCodeExport, setSourceCodeExport] = useState();
  const [dataRowSelect, setDataRowSelect] = useState<any[]>([]);
  const [dataRowProps, setDataRowProps] = useState<any[]>([]);
  console.log(dataRowProps);
  const [visible, { toggle, open, close }] = useDisclosure(false);
  // const [openGroup, setOpenGroup] = useState<boolean>(false);
  const [tblItemTransactionHeaderCommand, setTblItemTransactionHeaderCommand] =
    useState({
      transactionId: null,
      transactionCode: null,
      transactionDate: new Date(
        new Date().getTime() + 7 * 3600 * 1000,
      ).toISOString(),
      subSourceId: null,
      // sourceCode: `XBHN${new Date().getDate()}.${new Date().getMonth()}.${new Date()
      //   .getFullYear()
      //   .toString()
      //   .slice(-2)}.${Math.floor(100000 + Math.random() * 900000)}`,
      sourceCode: null,
      sourceType: null,
      branchId: null,
      subInvId: null,
      departmentId: null,
      status: null,
      description: null,
      parentSerial: null,
      atribute1: null,
      atribute2: null,
      atribute3: null,
      atribute4: null,
      atribute5: null,
      atribute6: null,
      atribute7: null,
      atribute8: null,
      atribute9: null,
      atribute10: null,
      createBy: null,
      createDate: new Date(
        new Date().getTime() + 7 * 3600 * 1000,
      ).toISOString(),
      lastUpdateDate: new Date(
        new Date().getTime() + 7 * 3600 * 1000,
      ).toISOString(),
      lastUpdateBy: null,
      type: null,
      finishDate: new Date(
        new Date().getTime() + 7 * 3600 * 1000,
      ).toISOString(),
      attribute11: null,
      attribute12: null,
      attribute13: null,
      attribute14: null,
      attribute15: null,
      attribute16: null,
      attribute17: null,
      attribute18: null,
      attribute19: null,
      attribute20: null,
    });
  const [navigateInWard, setNavigateInWard] = useState(false);
  const [navigateOutWard, setNavigateOutWard] = useState(false);
  const [navigateReturnCustomer, setNavigateReturnCustomer] = useState(false);
  const [creatorInfo, setCreatorInfo] = useState<any>(null);
  const userLogin = typeof window !== "undefined" ? JSON.parse(localStorage.getItem("userInfo") || "{}") : {};
  const [inspectorId, setInspectorId] = useState<string | null>(
    userLogin?.empId ? userLogin.empId.toString() : null
  );
  const [inspectorNote, setInspectorNote] = useState<string | null>(null);
  // In phiếu xuất trả khách
  const componentRefRC = React.useRef(null);
  const handlePrintRC = useReactToPrint({
    contentRef: componentRefRC,
    pageStyle: `
      @page {
        size:auto;
        margin: 5mm 0;
    }`,
  });
  const [dataPrintRC, setDataPrintRC] = useState<any>(null);
  const [triggerPrintRC, setTriggerPrintRC] = useState(false);
  //table state
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [selectIds, setSelectIds] = useState<string[]>([]);
  // const [deleteViewStatus, setDeleteViewStatus] = useState(false);
  //count
  const [timeLeft, setTimeLeft] = useState(60);
  const [isCounting, setIsCounting] = useState(false);
  //search
  const location = useLocation();
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";

  const [search, setSearch] = useState<any>({
    startDate:
      _searchJson && checkedPinSearch
        ? _searchJson?.startDate
        : new Date(
            new Date(new Date().setMonth(new Date().getMonth() - 1)).getTime() +
              7 * 60 * 60 * 1000,
          )?.toISOString(),
    endDate:
      _searchJson && checkedPinSearch
        ? _searchJson?.endDate
        : new Date(new Date().getTime() + 7 * 60 * 60 * 1000)?.toISOString(),
    vendorName: _searchJson && checkedPinSearch ? _searchJson?.vendorName : "",
    itemStatus: _searchJson && checkedPinSearch ? _searchJson?.itemStatus : "",
    debtStatus: _searchJson && checkedPinSearch ? _searchJson?.debtStatus : "",
    serialStatus:
      _searchJson && checkedPinSearch ? _searchJson?.serialStatus : [],
    branch: _searchJson && checkedPinSearch ? _searchJson?.branch : "",
    inv: _searchJson && checkedPinSearch ? _searchJson?.inv : "",
    // Bảng kê chứa cả hàng khách ("1") và hàng kho ("2"); mặc định chỉ xem hàng khách,
    // xoá ô lọc là xem cả hai. Dùng ?? để phiên lưu cũ (chưa có itemType) vẫn về mặc định.
    itemType:
      _searchJson && checkedPinSearch ? (_searchJson?.itemType ?? "1") : "1",
    serial: _searchJson && checkedPinSearch ? (_searchJson?.serial ?? "") : "",
  });

  // Phiếu kho đang được xem chi tiết. Dùng lại chính component của màn tạo mới
  // ở chế độ DETAIL để bố cục không bị lệch.
  const [voucherDetail, setVoucherDetail] = useState<{
    type: ServiceRepairVoucherType;
    data: any;
    rows: any[];
  } | null>(null);

  const openVoucherDetail = async (
    transactionCode: string,
    type: ServiceRepairVoucherType,
  ) => {
    if (!transactionCode) return;

    open();
    try {
      const data = await getServiceRepairVoucherDetail(transactionCode, type);
      if (!data) {
        NotificationExtension.Fails(
          `Không lấy được thông tin phiếu ${transactionCode} !`,
        );
        return;
      }
      setVoucherDetail({ type, data, rows: mapDetailSerialsToRows(data) });
    } finally {
      close();
    }
  };

  const [keySearch, setKeySearch] = useDebouncedState<string>(
    _searchJson && checkedPinSearch ? _searchJson?.keySearch : "",
    300,
  );

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "receiveTicketCode",
        header: "Mã phiếu dịch vụ",
        Cell: ({ renderedCellValue, row }) =>
          renderedCellValue && renderedCellValue !== null ? (
            <Tooltip label="Xem chi tiết">
                <Badge
                  radius="sm"
                  variant="outline"
                  fw={500}
                  color="blue"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    navigate("/service-repair/detail-receive-ticket", {
                      state: { id: Number(row.original.receiveTicketId) },
                    })
                  }
                >
                {renderedCellValue}
              </Badge>
            </Tooltip>
          ) : null,
        enableColumnActions: true,
        enableSorting: false,
        enableColumnFilter: false,
        size: 175,
      },
      {
        accessorKey: "invOrgCode",
        header: "Mã CN",
        enableColumnActions: true,
        enableSorting: false,
        enableColumnFilter: false,
        size: 80,
      },
      {
        accessorKey: "subInvName",
        header: "Kho",
        Cell: ({ row }) => (
          <Tooltip label={`${row.original.subInvCode || ""} - ${row.original.subInvName || ""}`} withArrow>
            <Text fw={500} size="12.5px" truncate="end">
              {row.original.subInvCode} - {row.original.subInvName}
            </Text>
          </Tooltip>
        ),
        enableColumnActions: true,
        enableSorting: false,
        enableColumnFilter: false,
        size: 185,
      },
      {
        accessorKey: "postionCode",
        header: "Vị trí kho",
        Cell: ({ row }) => {
          const displayValue = row.original.postionCode && row.original.positionname
            ? `${row.original.postionCode} - ${row.original.positionname}`
            : row.original.postionCode || "";
          return (
            <Tooltip label={displayValue} withArrow disabled={!displayValue}>
              <Text fw={500} size="12.5px" truncate="end">
                {displayValue}
              </Text>
            </Tooltip>
          );
        },
        enableColumnActions: true,
        enableSorting: false,
        enableColumnFilter: false,
        size: 175,
      },
      {
        accessorKey: "createDate",
        header: "Ngày nhập kho",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
        enableColumnActions: true,
        enableSorting: false,
        enableColumnFilter: false,
        size: 130,
      },
      {
        accessorKey: "scheduleTime",
        header: "Ngày hẹn trả",
        enableColumnActions: true,
        enableSorting: false,
        enableColumnFilter: false,
        size: 115,
        Cell: ({ renderedCellValue, row }: any) => (
          <Badge
            radius={"sm"}
            color={
              row.original.serialStatus !== "Trả khách"
                ? renderedCellValue &&
                  !isNaN(new Date(renderedCellValue).getTime()) &&
                  (new Date(renderedCellValue).getTime() -
                    new Date().getTime()) /
                    (1000 * 60 * 60 * 24) <
                    3 &&
                  (new Date(renderedCellValue).getTime() -
                    new Date().getTime()) /
                    (1000 * 60 * 60 * 24) >
                    0
                  ? "yellow"
                  : (new Date(renderedCellValue).getTime() -
                        new Date().getTime()) /
                        (1000 * 60 * 60 * 24) <
                        0 && renderedCellValue !== null
                    ? "red"
                    : renderedCellValue === null
                      ? "rgba(0, 0, 0, 0)"
                      : "blue"
                : "green"
            }
          >
            {renderedCellValue && formatDateTime(renderedCellValue)}
          </Badge>
        ),
      },
      {
        accessorKey: "processingMethod",
        header: "Hình thức xử lý",
        Cell: ({ renderedCellValue }) => (
          <Text fw={500} size="12.5px">
            {getValueById(
              String(renderedCellValue || ""),
              dataTblProcessingMethod,
              "label",
            ) || ""}
          </Text>
        ),
        enableColumnActions: true,
        enableSorting: false,
        enableColumnFilter: false,
        size: 120,
      },
      {
        accessorKey: "customerGroup",
        header: "Nhóm khách hàng",
        size: 145,
        Cell: ({ renderedCellValue }) => (
          <Tooltip label={renderedCellValue || ""} withArrow disabled={!renderedCellValue}>
            <Text size="12.5px" fw={500} truncate="end">
              {renderedCellValue}
            </Text>
          </Tooltip>
        ),
        enableColumnActions: true,
        enableSorting: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "custMeeting",
        header: "Khách hàng",
        Cell: ({ renderedCellValue }) => (
          <Tooltip label={renderedCellValue || ""} withArrow disabled={!renderedCellValue}>
            <Text size="12.5px" fw={500} truncate="end">
              {renderedCellValue}
            </Text>
          </Tooltip>
        ),
        enableColumnActions: true,
        enableSorting: false,
        enableColumnFilter: false,
        size: 115,
      },
      {
        accessorKey: "custPhone",
        header: "Số điện thoại",
        enableColumnActions: true,
        enableSorting: false,
        enableColumnFilter: false,
        size: 120,
      },
      {
        accessorKey: "meetingAddress",
        header: "Địa chỉ khách hàng",
        enableColumnActions: true,
        enableSorting: false,
        enableColumnFilter: false,
        Cell: ({ row }) => (
          <Tooltip label={row.original.meetingAddress || ""} withArrow disabled={!row.original.meetingAddress}>
            <Text fw={500} size="12.5px" truncate="end">
              {row.original.meetingAddress || ""}
            </Text>
          </Tooltip>
        ),
        size: 190,
      },
      {
        accessorKey: "itemCode",
        header: "Mã sản phẩm",
        enableColumnActions: true,
        enableSorting: false,
        enableColumnFilter: false,
        size: 120,
      },
      {
        accessorKey: "itemName",
        header: "Tên sản phẩm",
        Cell: ({ renderedCellValue }) => (
          <Tooltip label={renderedCellValue || ""} withArrow disabled={!renderedCellValue}>
            <Text size="12.5px" fw={500} truncate="end">
              {renderedCellValue}
            </Text>
          </Tooltip>
        ),
        enableColumnActions: true,
        enableSorting: false,
        enableColumnFilter: false,
        size: 275,
      },
      {
        accessorKey: "serial",
        header: "Mã serial",
        enableColumnActions: true,
        enableSorting: false,
        enableColumnFilter: false,
        size: 120,
      },
      {
        accessorKey: "conclusionError",
        header: "Mô tả lỗi",
        Cell: ({ renderedCellValue }) => (
          <Tooltip label={renderedCellValue || ""} withArrow disabled={!renderedCellValue}>
            <Text size="12.5px" fw={500} truncate="end">
              {renderedCellValue}
            </Text>
          </Tooltip>
        ),
        enableColumnActions: true,
        enableSorting: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "newItemCode",
        header: "Mã sản phẩm đổi mới",
        enableColumnActions: true,
        enableSorting: false,
        enableColumnFilter: false,
        size: 140,
      },
      {
        accessorKey: "newItemName",
        header: "Tên sản phẩm mới",
        Cell: ({ renderedCellValue }) => (
          <Tooltip label={renderedCellValue || ""} withArrow disabled={!renderedCellValue}>
            <Text size="12.5px" fw={500} truncate="end">
              {renderedCellValue}
            </Text>
          </Tooltip>
        ),
        enableColumnActions: true,
        enableSorting: false,
        enableColumnFilter: false,
        size: 325,
      },
      {
        accessorKey: "newSerial",
        header: "Serial đổi mới",
        enableColumnActions: true,
        enableSorting: false,
        enableColumnFilter: false,
        size: 120,
      },
      {
        accessorKey: "quantity",
        header: "Số lượng",
        size: 40,
        enableColumnActions: true,
        enableSorting: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "serialStatus",
        header: "Trạng thái serial",
        enableColumnActions: true,
        enableSorting: false,
        enableColumnFilter: false,
        size: 80,
      },
      {
        accessorKey: "debtStatus",
        header: "Trạng thái nợ",
        enableColumnActions: true,
        enableSorting: false,
        enableColumnFilter: false,
        size: 100,
      },
      {
        accessorKey: "iwCode",
        header: "Số phiếu nhập kho BH",
        Cell: ({ renderedCellValue }) => (
          <ServiceRepairVoucherCodeCell
            value={renderedCellValue}
            type="NHAP_KHO_BAO_HANH"
            onOpenDetail={openVoucherDetail}
          />
        ),
        enableColumnActions: true,
        enableSorting: false,
        enableColumnFilter: false,
        size: 150,
      },
      {
        accessorKey: "owWarrantyCode",
        header: "Mã phiếu xuất kho BH NCC",
        Cell: ({ renderedCellValue }) => (
          <ServiceRepairVoucherCodeCell
            value={renderedCellValue}
            type="XUAT_KHO_BAO_HANH_NCC"
            onOpenDetail={openVoucherDetail}
          />
        ),
        enableColumnActions: true,
        enableSorting: false,
        enableColumnFilter: false,
        size: 150,
      },

      {
        accessorKey: "iwWarrantyCode",
        header: "Số phiếu nhập kho BH NCC",
        Cell: ({ renderedCellValue }) => (
          <ServiceRepairVoucherCodeCell
            value={renderedCellValue}
            type="NHAP_KHO_BAO_HANH_NCC"
            onOpenDetail={openVoucherDetail}
          />
        ),
        enableColumnActions: true,
        enableSorting: false,
        enableColumnFilter: false,
        size: 150,
      },

      {
        accessorKey: "owReturnCode",
        header: "Số phiếu xuất trả khách",
        Cell: ({ renderedCellValue }) => (
          <ServiceRepairVoucherCodeCell
            value={renderedCellValue}
            type="XUAT_KHO_BAO_HANH"
            onOpenDetail={openVoucherDetail}
            color={green.base}
            size="lg"
          />
        ),
        enableColumnActions: true,
        enableSorting: false,
        enableColumnFilter: false,
        size: 150,
      },


      {
        accessorKey: "attribute16",
        header: "Nhà cung cấp",
        enableColumnActions: true,
        enableSorting: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "itemType",
        header: "Loại hàng",
        enableColumnActions: true,
        enableSorting: false,
        enableColumnFilter: false,
        size: 100,
      },

      {
        accessorKey: "serialNote",
        header: "Ghi chú",
        enableColumnActions: true,
        enableSorting: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "attribute21",
        header: "Mã phiếu nhập từ NCC",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue && renderedCellValue !== null ? (
            <Badge
              radius="sm"
              variant="outline"
              size="lg"
              color={renderedCellValue === null ? "red" : green.base}
            >
              {renderedCellValue === null
                ? "Chưa xuất tới NCC"
                : renderedCellValue}
            </Badge>
          ) : (
            <></>
          ),
        enableColumnActions: true,
        enableSorting: false,
        enableColumnFilter: false,
        size: 200,
      },

    ],
    [
      dataItemStatusSelect,
      dataDebtStatusSelect,
      dataTblProcessingMethod,
      // openGroup
    ],
  );

  const startCountdown = () => {
    if (!isCounting) {
      setTimeLeft(_timerDelayClick);
      setIsCounting(true);
    }
  };

  const handleChangeSearchValue = (value: string, key: string) => {
    if (value !== "Invalid date")
      setSearch((prevData: any) => ({ ...prevData, [key]: value }));
    else {
      setSearch((prevData: any) => ({ ...prevData, [key]: "" }));
    }
  };

  const handleChange = (serial: string, field: string, value: any) => {
    const updatedData = dataRowProps.map((item: any) =>
      item.serial?.toString() === serial?.toString()
        ? {
            ...item,
            [field]: value,
          }
        : item,
    );
    setDataRowProps(updatedData);
  };

  // const getColumnVisibility = () => {
  //   if (!openGroup) {
  //     return {
  //       id: false,
  //       soSerial: false,
  //       newSerial: false,
  //       soItemName: false,
  //     };
  //   } else if (openGroup) {
  //     return {
  //       id: false,
  //       soSerial: true,
  //       newSerial: true,
  //       soItemName: true,
  //     };
  //   }
  //   return {
  //     id: false,
  //     soSerial: false,
  //     newSerial: false,
  //     soItemName: false,
  //   };
  // };

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);

    let url = `?Skip=${pagination?.pageIndex * pagination?.pageSize}&Take=${
      pagination.pageSize
    }&CompanyCode=DVT`;

    if (keySearch.length > 0) {
      url += `&KeySearch=${keySearch}`;
    }

    if (search.startDate) {
      url += `&StartDate=${search.startDate}`;
    }

    if (search.endDate) {
      url += `&EndDate=${search.endDate}`;
    }

    if (search.vendorName) {
      url += `&VendorCode=${search.vendorName}`;
    }

    if (search.serialStatus && search.serialStatus?.length > 0) {
      url += `&SerialStatus=${search.serialStatus.filter((i: any) => i && String(i).length > 0).join(",")}`;
    }

    if (search.debtStatus) {
      url += `&DebtStatus=${search.debtStatus}`;
    }

    if (search.branch) {
      url += `&BranchId=${search.branch}`;
    }

    if (search.inv) {
      url += `&InventoryId=${search.inv}`;
    }

    if (search.itemType) {
      url += `&ItemType=${search.itemType}`;
    }

    if (search.serial?.trim()) {
      url += `&Serial=${encodeURIComponent(search.serial.trim())}`;
    }

    try {
      const response = await repositoryDelivery.get<
        MessageResponse<DefectiveItem[]>
      >(`/api/v1/DefectiveItemsList/get-list-service${url}`);
      if (response && response.success) {
        let result = response.data;
        setData(result);
        setDataTemp(response.data);
        setRowCount(response.totalCount);
        setSelectIds([]);
        table.resetRowSelection();
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    }
    setIsError(false);
    setIsLoading(false);
    setIsRefetching(false);
    sessionStorage.setItem(
      String(location.pathname),
      JSON.stringify({
        ...search,
        keySearch: keySearch,
      }),
    );
    startCountdown();
  };

  const handleExportData = async () => {
    open();
    try {
      let url = `/api/v1/DefectiveItemsList/export-defective-items-list-service?Skip=${
        pagination?.pageIndex * pagination?.pageSize
      }&Take=${pagination.pageSize}&CompanyCode=DVT`;

      if (keySearch.length > 0) {
        url += `&KeySearch=${keySearch}`;
      }

      if (search.startDate) {
        url += `&StartDate=${search.startDate}`;
      }

      if (search.endDate) {
        url += `&EndDate=${search.endDate}`;
      }

      if (search.vendorName) {
        url += `&VendorCode=${search.vendorName}`;
      }

      if (search.serialStatus && search.serialStatus?.length > 0) {
        url += `&SerialStatus=${search.serialStatus.filter((i: any) => i && String(i).length > 0).join(",")}`;
      }

      if (search.debtStatus) {
        url += `&DebtStatus=${search.debtStatus}`;
      }

      if (search.branch) {
        url += `&BranchId=${search.branch}`;
      }

      if (search.itemType) {
        url += `&ItemType=${search.itemType}`;
      }

      if (search.serial?.trim()) {
        url += `&Serial=${encodeURIComponent(search.serial.trim())}`;
      }

      const _url = BASE_API_DELIVERY + url;
      const token = localStorage.getItem("token");

      const response = await fetch(_url, {
        method: "GET",
        headers: {
          "Content-Type": "application/vnd.ms-excel",
          Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to download file");
      }
      const blob = await response.blob();
      const urlss = window.URL.createObjectURL(blob);
      const _name = new Date().toISOString().slice(0, 10);
      let filename = "bang_ke_hang_dich_vu" + _name + ".xlsx";
      const link = document.createElement("a");
      link.href = urlss;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };
  useEffect(() => {
    Promise.all([
      getDataVendorSelect(),
      getDataBranchSelect(),
      getDataInventorySelect(),
      processingMethodSelect(),
    ]);
  }, []);

  const handleVendorWarrantyOutward = async (
    itemTransaction: any,
    dep: boolean,
    supplier: string,
    description: string | null,
    transactionCode?: string
  ) => {
    const req = await repositoryPos.post<MessageResponse<any>>(
      "/api/v1/Outward/create-service-vendor-warranty-outward",
      {
        sourceId: 0,
        tblItemTransactionHeaderCommand: {
          ...tblItemTransactionHeaderCommand,
          sourceType: "XUAT_KHO_BAO_HANH_NCC",
          sourceCode: sourceCodeExport,
          // Không gửi atribute6: phiếu xuất gửi NCC không có chứng từ gốc,
          // backend dùng trường này để lưu danh sách Id bảng kê của các serial trên phiếu.
          description: description,
          attribute15: supplier,
          transactionCode: transactionCode,
        },
        serials: dataRowSelect.map((item) => ({
          ...item,
          attribute7: supplier,
        })),
        // Luôn gửi thông tin giao vận để lưu vào Attribute20 phục vụ màn xem chi tiết;
        // backend chỉ sinh phiếu giao vận khi deliveryDepartment = NOI_BO.
        deliveryInfo: {
          deliveryDepartment: itemTransaction.departmentId ?? "KHONG",
          customerId: itemTransaction.customerId,
          customerName: itemTransaction.customerName,
          telephoneNumber: itemTransaction.telephoneNumber,
          customerAddress: itemTransaction.customerAddress,
          toAddress: itemTransaction.toAddress,
          customerProvinceId: itemTransaction.customerProvinceId,
          customerDistrictId: itemTransaction.customerDistrictId,
          customerCommuneId: itemTransaction.customerCommuneId,
          customerStreetId: itemTransaction.customerStreetId,
          deliveryAppointmentTime: itemTransaction.deliveryAppointmentTime,
          priority: itemTransaction.priority
            ? Number(itemTransaction.priority)
            : null,
          description: itemTransaction.description,
          content: itemTransaction.content,
        },
      },
    );

    if (req && req?.success) {
      modals.closeAll();
      await fetchData();
      NotificationExtension.Success("Xuất bảo hành nhà cung cấp thành công !");
      return true;
    }
    return false;
  };

  const handleWarrantyOutward = async (dep: boolean, itemTransaction: any) => {
    const req = await repositoryPos.post<MessageResponse<any>>(
      "/api/v1/Outward/create-service-return-customer-outward",
      {
        header: {
          branchId: tblItemTransactionHeaderCommand.branchId,
          subInvId: tblItemTransactionHeaderCommand.subInvId,
          transactionDate: tblItemTransactionHeaderCommand.transactionDate,
          attribute6: dataRowProps[0]?.iwId,
          sourceCode: dataRowProps[0]?.iwCode,
          description: itemTransaction.description,
        },
        serials: dataRowSelect?.map((item: any) => ({
          ...item,
          serialStatus: "Trả khách",
          transactionSourceTypeCode: "XUAT_KHO_BAO_HANH",
        })),
        // Luôn gửi thông tin khách hàng + giao vận để lưu vào Attribute20 phục vụ
        // màn xem chi tiết; backend chỉ sinh phiếu giao vận khi deliveryDepartment = NOI_BO.
        deliveryInfo: {
          deliveryDepartment: itemTransaction.departmentId ?? "KHONG",
          customerId: itemTransaction.customerId,
          customerName: itemTransaction.customerName,
          telephoneNumber: itemTransaction.telephoneNumber,
          customerAddress: itemTransaction.customerAddress,
          toAddress: itemTransaction.toAddress,
          customerProvinceId: itemTransaction.customerProvinceId,
          customerDistrictId: itemTransaction.customerDistrictId,
          customerCommuneId: itemTransaction.customerCommuneId,
          customerStreetId: itemTransaction.customerStreetId,
          deliveryAppointmentTime: itemTransaction.deliveryAppointmentTime,
          priority: itemTransaction.priority
            ? Number(itemTransaction.priority)
            : null,
          description: itemTransaction.description,
          content: itemTransaction.content,
        },
      },
    );

    if (req && req?.success) {
      modals.closeAll();
      await fetchData();
      NotificationExtension.Success("Xuất trả khách thành công !");
      return true;
    }
    return false;
  };

  const handleWarrantyInward = async () => {
    const req = await repositoryPos.post<MessageResponse<any>>(
      "/api/v1/Inward/create-service-vendor-warranty-inward",
      {
        sourceId: 0,
        inspectorId: inspectorId ? Number(inspectorId) : null,
        inspectorNote: inspectorNote ? inspectorNote.trim() : null,
        tblItemTransactionHeaderCommand: {
          ...tblItemTransactionHeaderCommand,
          sourceType: "NHAP_KHO_BAO_HANH_NCC",
          // Chứng từ gốc của phiếu nhập là phiếu xuất gửi nhà cung cấp
          sourceCode: dataRowProps[0]?.owWarrantyCode ?? null,
          atribute6: dataRowProps[0]?.owWarrantyId ?? null,
        },
        serials: dataRowSelect?.map((item: any) => {
          const { parentSerial, formChange, attribute4, attribute5 } = item;
          const isChanged = formChange === "DOI_MOI" || formChange === "DOI_TUONG_DUONG";
          const finalNewItemId = isChanged ? (attribute4 ? String(attribute4) : null) : (item.newItemId ? String(item.newItemId) : null);
          const finalNewSerial = isChanged ? (attribute5 ? attribute5.trim() : null) : (item.newSerial ? item.newSerial.trim() : null);

          return {
            serial: item.serial,
            invId: item.invId,
            transactionQuantity: 1,
            primaryQuantity: 1,
            defectiveId: item.id,
            locatorId: item.locatorId,
            itemId: item.itemId,
            newItemId: finalNewItemId,
            newSerial: finalNewSerial,
            serialStatus: "Chờ test",
            note: item.attribute11 ? item.attribute11.trim() : null,
            ...(parentSerial && String(parentSerial).length > 0
              ? {
                  tblInventoryChildSerialOnhandCommands: [
                    {
                      parentSerial:
                        finalNewSerial && String(finalNewSerial).length > 0
                          ? finalNewSerial
                          : item.serial,
                      serial: parentSerial,
                      itemCode: "Chờ test",
                      itemName: item.itemName,
                      uomCode: "",
                      quantity: 1,
                      warrantyPeriod: 0,
                    },
                  ],
                }
              : {}),
          };
        }),
      },
    );

    if (req && req?.success) {
      NotificationExtension.Success("Nhập kho bảo hành thành công !");
      setTimeout(() => {
        setNavigateInWard(false);
      }, 1000);
      // setTimeout(() => {
      //   setDeleteViewStatus(!deleteViewStatus);
      //   setNavigateInWard(false);
      // }, 1000);
    }
  };

  const getDataVendorSelect = async () => {
    const getData = await repositoryMdm.get<MessageResponse<any>>(
      "/api/v1/TblVendor/get-all",
    );

    if (getData && getData?.success) {
      const result = getData.data;
      setDataVendorSelect(
        result
          ?.filter(
            (item: any) => item.vendorName != null && item.vendorCode != null,
          )
          ?.map((item: any) => ({
            value: item.vendorCode,
            label: `${item.vendorCode} - ${item.vendorName}`,
          })),
      );
    }
  };

  const getDataInventorySelect = async () => {
    const getData = await getTblDMInventory();

    setDataInventorySelect(
      getData
        ?.filter(
          (item) =>
            item.value != null &&
            item.text != null &&
            (item.text?.includes("BH") ||
              item.text?.includes("BK") ||
              item.text?.includes("DV")),
        )
        ?.map((item: any) => ({
          value: item.value,
          // Hiển thị "Mã CN - Tên CN" (att2 = mã chi nhánh)
          label: item.att2 ? `${item.att2} - ${item.text}` : item.text,
        })),
    );
  };

  const getDataBranchSelect = async () => {
    const getData = await getBranchSelectMdm();
    setDataBranchSelect(
      getData
        ?.filter(
          (item: any) =>
            item.value != null &&
            item.text != null &&
            item.value != "-1" &&
            // Dịch vụ sửa chữa chỉ làm việc với chi nhánh pháp nhân DVT (attr6 = CompanyCode)
            item.attr6 === "DVT",
        )
        ?.map((item) => ({
          value: item.value,
          label: item.text,
        })),
    );
  };

  const processingMethodSelect = async () => {
    try {
      const getData = await getTblDmProcessingMethodSelect();
      const filteredData = getData?.filter(
        (item) => item.value != null && item.text != null,
      );
      const mappedData = filteredData?.map((item) => ({
        value: item.value,
        label: item.text,
      }));
      setDataTblProcessingMethod(mappedData);
    } catch (error) {
      console.error("Error in dataTblLocation: ", error);
    }
  };

  const updateWarrantyTerm = (listSerial: any) => {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Cập nhật hạn BH sản phẩm</Title>
        </>
      ),
      size: "auto",
      children: (
        <UpdateWarrantyTerm
          dataSerial={listSerial}
          setDeleteViewStatus={fetchData}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  function outWardWarrantyVendor() {
    setNavigateOutWard(true);
  }

  const modalsReturnCustomer = async (dataItem: any) => {
    if (dataItem && dataItem[0]?.receiveTicketCode) {
      const res = await repositoryPos.get<MessageResponse<any>>(
        `/api/v1/Outward/create-service-return-customer-outward?receiveTicketCode=${dataItem[0].receiveTicketCode}`,
      );
      if (res && res.success) {
        setCreatorInfo(res.data);
        setNavigateReturnCustomer(true);
      } else {
        NotificationExtension.Fails(res?.message || "Không thể lấy thông tin phiếu dịch vụ!");
      }
    } else {
      NotificationExtension.Fails("Không có mã phiếu dịch vụ!");
    }
  };

  /**
   * In phiếu xuất trả khách: gọi API riêng của Dịch vụ sửa chữa.
   * - Từ bảng kê: in ĐÚNG các dòng đang tích (`ids`) — một phiếu in gom nhiều dòng cùng mã phiếu
   *   dịch vụ, có thể thuộc nhiều phiếu xuất khác nhau.
   * - Từ màn xuất trả / chi tiết phiếu xuất: in cả phiếu theo `outwardCode`, vì ở đó chỉ có mã
   *   phiếu xuất chứ không có id bảng kê.
   */
  const handlePrintReturnCustomer = async (args?: {
    ids?: number[];
    outwardCode?: string;
  }) => {
    const selectedIds = (args?.ids ?? dataRowProps
      .map((row: any) => row?.id))
      .filter((id: any) => id !== null && id !== undefined);
    const outwardCode = args?.outwardCode?.trim();

    if (selectedIds.length === 0 && !outwardCode) {
      NotificationExtension.Fails("Chưa chọn sản phẩm để in phiếu xuất trả khách !");
      return;
    }

    open();
    try {
      const query = outwardCode
        ? `outwardCode=${encodeURIComponent(outwardCode)}`
        : selectedIds.map((id: any) => `ids=${id}`).join("&");
      const res = await repositoryDelivery.get<MessageResponse<any>>(
        `/api/v1/DefectiveItemsList/print-return-customer-service?${query}`,
      );

      if (res && res.success && res.data) {
        setDataPrintRC(res.data);
        setTriggerPrintRC(true);
      }
    } catch (error) {
      console.error(error);
    } finally {
      close();
    }
  };

  // Chờ dữ liệu in được set vào DOM (component ẩn) rồi mới gọi in
  useEffect(() => {
    if (triggerPrintRC && dataPrintRC) {
      handlePrintRC();
      setTriggerPrintRC(false);
    }
  }, [triggerPrintRC, dataPrintRC]);

  useEffect(() => {
    let timer: ReturnType<typeof setInterval>;
    if (isCounting && timeLeft > 0) {
      timer = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);
    } else if (timeLeft === 0) {
      setIsCounting(false);
    }
    return () => clearInterval(timer);
  }, [isCounting, timeLeft]);

  useEffect(() => {
    const valuesList = Object.keys(rowSelection);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelection);
      setSelectIds(valuesList);
    }
  }, [rowSelection]);

  useEffect(() => {
    if (!navigateInWard) {
      fetchData();
    }
  }, [pagination.pageIndex, pagination.pageSize, navigateInWard]);

  useEffect(() => {
    const numericIds = selectIds.map((item) => item);

    const filtered = data.filter((item) =>
      numericIds.includes(item.id?.toString()),
    );

    const filtered2 = filtered?.map((item: any) => ({
      ...item,
      // Nếu có newItemCode → dùng new item info + new serial
      // Nếu chỉ có newSerial → dùng new serial, giữ item cũ
      // Nếu không có gì mới → giữ tất cả cũ
      serial: item.newItemCode
        ? (item.newSerial?.trim() || item.serial?.trim())
        : item.newSerial
          ? item.newSerial.trim()
          : item.serial?.trim(),
      itemCode: item.newItemCode ? item.newItemCode : item.itemCode,
      itemName: item.newItemCode ? (item.newItemName || item.itemName) : item.itemName,
      inventoryItemId: item.newItemCode
        ? (item.newItemId || item.itemId)
        : item.itemId,
      invId: item.subInvId,
      locatorId: item.positionid,
      primaryQuantity: 1,
      transactionQuantity: 1,
      serialStatus: "Đang gửi nhà cung cấp",
      defectiveId: item.id,
      attribute7: null,
      organizationId: item?.invOrgId,
      primaryUom: item.uomCode,
    }));

    if (selectIds.length > 0) {
      setSelectStatusSerial(filtered[0]?.serialStatus);
      setIsReturnedBorrowGoods(filtered[0]?.isReturnedBorrowGoods);
      setListErrorNum(filtered?.map((item: any) => item.receiveTicketCode));
      setDataRowProps(filtered);
    } else {
      setSelectStatusSerial(null);
      setIsReturnedBorrowGoods(null);
    }
    // attribute2 của bảng kê là id vị trí kho, không phải mã chứng từ
    setSourceCodeExport(filtered[0]?.iwCode);
    setDataRowSelect(filtered2);
    setTblItemTransactionHeaderCommand((prev) => ({
      ...prev,
      subInvId: filtered[0]?.subInvId,
      branchId: filtered[0]?.invOrgId,
    }));
  }, [selectIds]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (210 + headerHeight));
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [height]);

  const styleGrid = { base: 12, xs: 4, sm: 3, lg: 2 };

  const getColumnPinningStorage = () => {
    const columnPinningStorage = localStorage.getItem(
      "columnPinningServiceRepairDefectiveGoodsList",
    );
    return columnPinningStorage
      ? JSON.parse(columnPinningStorage)
      : {
          left: ["mrt-row-select", "mrt-row-numbers"],
          right: ["action"],
        }; // Giá trị mặc định
  };

  // Lưu columnPinning vào state
  const [columnPinning, setColumnPinning] = useState<ColumnPinningType>(
    getColumnPinningStorage(),
  );

  // Hàm lưu vào localStorage
  useEffect(() => {
    localStorage.setItem(
      "columnPinningServiceRepairDefectiveGoodsList",
      JSON.stringify(columnPinning),
    );
  }, [columnPinning]);

  // Bảng kê dịch vụ chứa cả hàng khách (Attribute7 = "1") và hàng kho (Attribute7 = "2").
  // Hàng kho không thuộc khách hàng nào: không xuất trả khách, thay bằng điều chuyển trả về kho gốc.
  const selectedRows = data.filter((item: any) =>
    selectIds.includes(item.id?.toString()),
  );
  const isStockGoodsRow = (row: any) =>
    String(row?.attribute7 ?? "").trim() === "2" ||
    String(row?.itemType ?? "").trim() === "Hàng kho";
  const stockGoodsCount = selectedRows.filter(isStockGoodsRow).length;
  const isStockGoodsOnly =
    selectedRows.length > 0 && stockGoodsCount === selectedRows.length;
  const isCustomerGoodsOnly =
    selectedRows.length > 0 && stockGoodsCount === 0;
  const isMixedItemType =
    stockGoodsCount > 0 && stockGoodsCount < selectedRows.length;

  /**
   * Hàng kho sau khi Test OK được trả về chi nhánh gốc bằng phiếu điều chuyển nội bộ.
   * Dùng đúng luồng điều chuyển hiện có, chỉ truyền danh sách serial sang màn tạo yêu cầu.
   * Serial/mã hàng ưu tiên thông tin mới nếu NCC đã đổi trả.
   */
  const handleTransferStockGoods = () => {
    const listSerial = selectedRows.map((item: any) => ({
      ...item,
      serial: item.newSerial ? item.newSerial?.trim() : item.serial?.trim(),
      itemCode: item.newItemCode ? item.newItemCode : item.itemCode,
      itemId: item.newItemId ? item.newItemId : item.itemId,
      itemName: item.newItemName ? item.newItemName : item.itemName,
    }));

    const date = new Date();
    date.setHours(date.getHours() + 7);

    navigate("/warehouse-config/create-request-transfer", {
      state: {
        listSerialProps: listSerial,
        type: "DIEU_CHUYEN_NOI_BO_SERIAL",
        createDate: date?.toISOString(),
        typeView: 3,
        typeRequestTransfer: 2,
      },
    });
  };

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: true,
    enableRowNumbers: true,
    positionToolbarAlertBanner: "bottom",
    columnFilterDisplayMode: "popover",
    enableRowSelection: (row) => {
      // Dòng đã "Trả khách" vẫn cho tích để IN LẠI phiếu xuất trả. An toàn vì mọi
      // thao tác nhập/xuất đều đã tự chặn theo trạng thái: Xuất BH NCC cần "Test lỗi"/
      // "Bán bình thường", Nhập BH NCC cần "Đang gửi nhà cung cấp", Xuất trả khách cần
      // "Test OK"/"Hủy", Điều chuyển cần "Test OK".
      if (selectStatusSerial === null || selectStatusSerial === "") {
        return true;
      } else {
        return row.original.serialStatus === selectStatusSerial;
      }
    },
    //add custom action buttons to top-left of top toolbar
    renderTopToolbarCustomActions: ({ row }: any) => (
      <div ref={headerRef} style={{ width: "100%" }}>
        <Grid mt={10}>
          <Grid.Col span={styleGrid}>
            <DatePickerInput
              size="sm"
              placeholder="Từ ngày"
              leftSection={<IconCalendar color="#15aabf" />}
              locale="vi"
              valueFormat="DD/MM/YYYY"
              value={
                search.startDate && search.startDate.length > 0
                  ? new Date(search.startDate)
                  : null
              }
              maxDate={
                search.endDate && search.endDate?.length > 0
                  ? new Date(search.endDate)
                  : new Date()
              }
              onChange={(e) => {
                handleChangeSearchValue(
                  formatDateNotTimeZone(e) ?? "",
                  "startDate",
                );
              }}
              clearable
            />
          </Grid.Col>
          <Grid.Col span={styleGrid}>
            <DatePickerInput
              size="sm"
              placeholder="Đến ngày"
              leftSection={<IconCalendar color="#15aabf" />}
              locale="vi"
              valueFormat="DD/MM/YYYY"
              value={
                search.endDate && search.endDate.length > 0
                  ? new Date(search.endDate)
                  : null
              }
              minDate={
                search.startDate && search.startDate?.length > 0
                  ? new Date(search.startDate)
                  : undefined
              }
              onChange={(e) => {
                handleChangeSearchValue(
                  formatDateNotTimeZone(e) ?? "",
                  "endDate",
                );
              }}
              clearable
            />
          </Grid.Col>
          <Grid.Col span={styleGrid}>
            <Select
              placeholder="Nhà cung cấp"
              data={dataVendorSelect}
              value={search.vendorName || null}
              leftSection={<IconBuildingSkyscraper color="#15aabf" />}
              searchable
              clearable
              nothingFoundMessage="Không tìm thấy dữ liệu !"
              comboboxProps={{ width: 425 }}
              onChange={(e) => handleChangeSearchValue(e ?? "", "vendorName")}
            />
          </Grid.Col>
          <Grid.Col span={styleGrid}>
            <MultiSelect
              placeholder="Trạng thái sản phẩm"
              data={dataItemStatusSelect}
              value={search.serialStatus || []}
              leftSection={<IconChartCandle color="#15aabf" />}
              searchable
              clearable
              nothingFoundMessage="Không tìm thấy dữ liệu !"
              onChange={(e) =>
                setSearch((prevData: any) => ({
                  ...prevData,
                  serialStatus: e || [],
                }))
              }
            />
          </Grid.Col>
          <Grid.Col span={styleGrid}>
            <Select
              placeholder="Chi nhánh"
              searchable
              clearable
              value={search.branch || null}
              leftSection={<IconBrandBootstrap color="#15aabf" />}
              data={dataBranchSelect}
              onChange={(e) =>
                handleChangeSearchValue(e?.toString() ?? "", "branch")
              }
              nothingFoundMessage="Không tìm thấy dữ liệu !"
            />
          </Grid.Col>
          <Grid.Col span={styleGrid}>
            <Select
              placeholder="Kho"
              data={dataInventorySelect}
              value={search.inv || null}
              searchable
              clearable
              leftSection={<IconBuildingWarehouse color="#15aabf" />}
              nothingFoundMessage="Không tìm thấy dữ liệu !"
              onChange={(e) => handleChangeSearchValue(e ?? "", "inv")}
            />
          </Grid.Col>
          <Grid.Col span={styleGrid}>
            <Select
              placeholder="Loại hàng"
              data={[
                { value: "1", label: "Hàng khách" },
                { value: "2", label: "Hàng kho" },
              ]}
              value={search.itemType || null}
              leftSection={<IconPackage color="#15aabf" />}
              clearable
              onChange={(e) => handleChangeSearchValue(e ?? "", "itemType")}
            />
          </Grid.Col>
          <Grid.Col span={styleGrid}>
            <Select
              placeholder="Trạng thái nợ"
              data={dataDebtStatusSelect}
              value={search.debtStatus || null}
              leftSection={<IconBrandGrammarly color="#15aabf" />}
              searchable
              clearable
              nothingFoundMessage="Không tìm thấy dữ liệu !"
              onChange={(e) => handleChangeSearchValue(e ?? "", "debtStatus")}
            />
          </Grid.Col>
          <Grid.Col span={styleGrid}>
            <TextInput
              placeholder="Mã serial"
              leftSection={<IconSearch color="#15aabf" />}
              value={search.serial ?? ""}
              onChange={(e) =>
                handleChangeSearchValue(e.currentTarget.value, "serial")
              }
              onKeyDown={async (e) => {
                if (e.key === "Enter") {
                  await fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={styleGrid}>
            <TextInput
              placeholder="Nhập từ khóa"
              leftSection={<IconSearch color="#15aabf" />}
              defaultValue={keySearch}
              onChange={(e) => setKeySearch(e.currentTarget.value)}
              onKeyDown={async (e) => {
                if (e.key === "Enter") {
                  await fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={styleGrid}>
            <Button
              variant="outline"
              color="blue"
              leftSection={<IconSearch size={14} />}
              onClick={fetchData}
              w={"100%"}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
      </div>
    ),
    renderToolbarInternalActions: ({ table }) => <></>,

    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    getRowId: (row) => row.id?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        ...columnPinning,
      },
      // columnVisibility: getColumnVisibility(),
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onColumnPinningChange: (newState) => {
      setColumnPinning(newState);
    },
    onRowSelectionChange: setRowSelection,
    manualFiltering: true,
    manualPagination: true,
    manualSorting: true,
    rowCount,
    // onColumnFiltersChange: setColumnFilters,
    // onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    // onSortingChange: setSorting,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTableMantine,
    }),
    state: {
      // columnFilters,
      // globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      //sorting,
      rowSelection,
      columnPinning,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["20", "50"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    mantineTableBodyRowProps: ({ row }) => ({
      onClick: row.getToggleSelectedHandler(),
      sx: { cursor: "pointer" },
    }),
  });

  // React.useEffect(() => {
  //   const newColumnVisibility = getColumnVisibility();
  //   if (table) {
  //     table.setColumnVisibility(newColumnVisibility);
  //   }
  // }, [openGroup, table]);

  /** Màn xem chi tiết dùng lại đúng component của màn tạo mới, chỉ khác mode. */
  const renderVoucherDetail = () => {
    if (!voucherDetail) return null;

    const { type, data, rows } = voucherDetail;
    const back = () => setVoucherDetail(null);

    if (type === "NHAP_KHO_BAO_HANH") {
      return (
        <ServiceRepairInWardWarranty back={back} dataRowProps={rows} detail={data} />
      );
    }

    if (type === "NHAP_KHO_BAO_HANH_NCC") {
      return (
        <ServiceRepairInWardWarrantyVendor
          back={back}
          dataRowProps={rows}
          setDataRowProps={() => {}}
          typeView="KHO"
          dataVendorSelect={dataVendorSelect}
          mode="DETAIL"
          detail={data}
        />
      );
    }

    if (type === "XUAT_KHO_BAO_HANH_NCC") {
      return (
        <ServiceRepairOutWardWarrantyVendor
          back={back}
          invId={data?.inventoryId}
          dataRowProps={rows}
          mode="DETAIL"
          detail={data}
        />
      );
    }

    return (
      <ServiceRepairReturnCustomers
        back={back}
        dataRowProps={rows}
        handleChange={() => {}}
        id={data?.receiveTicketId}
        typeView="KHACH"
        mode="DETAIL"
        detail={data}
        onPrintReturnCustomer={handlePrintReturnCustomer}
      />
    );
  };

  return (
    <>
      {voucherDetail ? (
        renderVoucherDetail()
      ) : navigateInWard ? (
        <ServiceRepairInWardWarrantyVendor
          back={setNavigateInWard}
          dataRowProps={dataRowSelect}
          setDataRowProps={setDataRowSelect}
          handleWarrantyInward={handleWarrantyInward}
          typeView="KHO"
          dataVendorSelect={dataVendorSelect}
          setTblItemTransactionHeaderCommand={setTblItemTransactionHeaderCommand}
          inspectorId={inspectorId}
          setInspectorId={setInspectorId}
          inspectorNote={inspectorNote}
          setInspectorNote={setInspectorNote}
        />
      ) : navigateOutWard ? (
        <ServiceRepairOutWardWarrantyVendor
          back={setNavigateOutWard}
          handleVendorWarrantyOutward={handleVendorWarrantyOutward}
          invId={dataRowSelect[0]?.invId}
          dataRowProps={dataRowProps}
        />
      ) : navigateReturnCustomer ? (
        <ServiceRepairReturnCustomers
          dataRowProps={dataRowProps}
          handleChange={handleChange}
          handleWarrantyOutward={handleWarrantyOutward}
          id={dataRowProps[0]?.requestFormId}
          typeView="KHACH"
          back={setNavigateReturnCustomer}
          creatorInfo={creatorInfo}
          onPrintReturnCustomer={handlePrintReturnCustomer}
        />
      ) : (
        <>
          <LoadingOverlay
            visible={visible}
            zIndex={1000}
            overlayProps={{ radius: "sm", blur: 5 }}
            loaderProps={{
              children: (
                <Flex direction={"column"} align="center" gap="xs">
                  <Loader type="dots" size={35}></Loader>
                  {/* <Title size={15}> Đang upload tài liệu...</Title> */}
                  <Title size={15}> Đang xử lý....</Title>
                </Flex>
              ),
            }}
          />
          <Flex justify={"space-between"} wrap={"wrap"}>
            <_breadcrumb></_breadcrumb>
            <Flex gap={"sm"} align={"center"} wrap={"wrap"} mb={"xs"}>
              <Badge color="red" />
              <Text fw={500} size="12.5px">
                Quá hạn
              </Text>
              <Badge color="blue" />
              <Text fw={500} size="12.5px">
                Chưa đến hạn
              </Text>
              <Badge color="yellow" />
              <Text fw={500} size="12.5px">
                Sắp đến hạn
              </Text>
              <Badge color="green" />
              <Text fw={500} size="12.5px">
                Đã trả khách
              </Text>
            </Flex>
            <Flex
              gap="md"
              justify="end"
              align="center"
              direction="row"
              wrap="wrap"
            >
              <Tooltip
                multiline
                w={280}
                label="Chọn các sản phẩm đã xuất trả khách và cùng một phiếu tiếp nhận hàng lỗi để in."
              >
                <Button
                  leftSection={<IconPrinter size={14} />}
                  variant="outline"
                  disabled={
                    !(
                      dataRowSelect.length > 0 &&
                      // chỉ in được sau khi đã xuất trả khách
                      selectStatusSerial === "Trả khách" &&
                      new Set(listErrorNum).size === 1 &&
                      listErrorNum.every((item) => item)
                    )
                  }
                  onClick={() => handlePrintReturnCustomer()}
                >
                  In phiếu xuất trả khách
                </Button>
              </Tooltip>
              <Menu>
                <Menu.Target>
                  <Button
                    size="sm"
                    variant="outline"
                    rightSection={
                      <IconCaretDown
                        style={{ width: rem(14), height: rem(14) }}
                      />
                    }
                  >
                    Nhập/Xuất Serial
                  </Button>
                </Menu.Target>
                <Menu.Dropdown>
                  <Menu.Item
                    leftSection={<IconTransferOut size={14} />}
                    disabled={
                      selectIds.length === 0 ||
                      isMixedItemType ||
                      (selectStatusSerial !== "Test lỗi" &&
                        selectStatusSerial !== "Bán bình thường")
                    }
                    // onClick={() => handleVendorWarrantyOutward()}
                    onClick={() => outWardWarrantyVendor()}
                  >
                    Xuất BH NCC
                  </Menu.Item>
                  <Menu.Item
                    leftSection={<IconTransferIn size={14} />}
                    onClick={() => setNavigateInWard(true)}
                    disabled={
                      selectIds.length === 0 ||
                      isMixedItemType ||
                      selectStatusSerial !== "Đang gửi nhà cung cấp"
                    }
                  >
                    Nhập BH NCC
                  </Menu.Item>
                  <Menu.Item
                    leftSection={<IconCubeSend size={14} />}
                    onClick={() => {
                      modalsReturnCustomer(dataRowProps);
                    }}
                    disabled={
                      selectIds.length === 0 ||
                      !isCustomerGoodsOnly ||
                      // Serial "Hủy" cũng được xuất trả khách như "Test OK"
                      (selectStatusSerial !== "Test OK" &&
                        selectStatusSerial !== "Hủy") ||
                      isReturnedBorrowGoods === 0.0 ||
                      listErrorNum.every((item) => item === listErrorNum[0]) ===
                        false ||
                      listErrorNum.every((item) => item !== null) === false
                    }
                  >
                    Xuất trả khách
                  </Menu.Item>
                  <Menu.Item
                    leftSection={<IconArrowsExchange size={14} />}
                    onClick={() => handleTransferStockGoods()}
                    disabled={
                      selectIds.length === 0 ||
                      !isStockGoodsOnly ||
                      selectStatusSerial !== "Test OK"
                    }
                  >
                    Điều chuyển
                  </Menu.Item>
                  {isMixedItemType ? (
                    <Menu.Label c="red">
                      Không thao tác đồng thời hàng khách và hàng kho
                    </Menu.Label>
                  ) : null}
                </Menu.Dropdown>
              </Menu>
              <Menu shadow="md">
                <Menu.Target>
                  <Button
                    size="sm"
                    variant="outline"
                    rightSection={
                      <IconCaretDown
                        style={{ width: rem(14), height: rem(14) }}
                      />
                    }
                  >
                    Export/Import Excel
                  </Button>
                </Menu.Target>

                <Menu.Dropdown>
                  <Menu.Item
                    leftSection={
                      <IconFileExport
                        style={{ width: rem(14), height: rem(14) }}
                      />
                    }
                    onClick={() => handleExportData()}
                  >
                    Export Excel
                  </Menu.Item>
                  <Tooltip label={"Chức năng đang update"}>
                    <Menu.Item
                      leftSection={
                        <IconFileUpload
                          style={{ width: rem(14), height: rem(14) }}
                        />
                      }
                    >
                      Import Excel
                    </Menu.Item>
                  </Tooltip>
                </Menu.Dropdown>
              </Menu>
            </Flex>
          </Flex>
          <MantineReactTable table={table} />
        </>
      )}

      {/* Khung in luôn được mount: còn in được cả từ màn xuất trả và màn chi tiết phiếu xuất,
          không chỉ từ lưới bảng kê */}
      <Box display={"none"}>
        <PrinterServiceReturnCustomers
          innerRef={componentRefRC}
          dataPrint={dataPrintRC ?? {}}
        />
      </Box>
    </>
  );
};

export default ServiceRepairDefectiveGoodsList;
